import { authClient, API } from "../../utils/index";

export const getPromoPortfolioProjectsAdmin = () => {
	return authClient().get(`${API}/promo-portfolio-project?all=1`);
};

export const getPromoPortfolioProjectById = (id) => {
	return authClient().get(`${API}/promo-portfolio-project/${id}`);
};

export const postPromoPortfolioProject = (body) => {
	return authClient().post(`${API}/promo-portfolio-project`, body);
};

export const putPromoPortfolioProject = (id, body) => {
	return authClient().put(`${API}/promo-portfolio-project/${id}`, body);
};

export const movePromoPortfolioProject = (id, direction) => {
	return authClient().post(`${API}/promo-portfolio-project/${id}/move`, { direction });
};

export const deletePromoPortfolioProject = (id) => {
	return authClient().delete(`${API}/promo-portfolio-project/${id}`);
};
